<template>
  <div>
    <div class="row">
        <div class="col-12">
          <flash message="" class="pl-4"></flash>
        </div>
    </div>

    <div class="d-flex justify-content-center min-vh-80">
      
      <div class="align-self-center flex-grow-1">

        <div class="plan-selector row my-md-5 justify-content-center">
          <div id="package_2" @click="setSelected($event,12)" class="col-12 col-md-5 plan best-deal order-1 order-md-2 selected">
            <div class="d-none d-md-block">
              <div class="plan-box text-center">
                <div class="checkmark">
                  <div class="glyphicon glyphicon-ok"></div>
                </div>
                <div class="plan-name">Early Trial</div>
                <div class="crossed-out-price">
                  <div class="crossed-out-monthly-amount">$9.99</div>
                </div>
                <div class="plan-amount">
                  <div class="price">
                    <div class="sup"> $ </div>
                    <div class="monthly-amount"> 0.00 </div>
                  </div>
                </div>
                <div class="divider"></div>
                <div class="thirty-day pb-5"> Free 30 days premium plan. </div>
                <div class="choose pt-4">
                  <button type="button" class="btn btn-choose btn-block mx-auto d-block w-50" @click="applyFreeTrial($event)">Apply</button>
                </div>
              </div>
            </div>
            <div class="d-block d-md-none mt-5">
              <div class="plan-box">
                <div class="plan-name">
                  <div class="plan-duration pt-3">
                    <span class="months_number">Early Trial</span>
                  </div>
                  <span class="savings-checkmark  pt-3">
                    <span class="checkmark">
                      <span class="glyphicon glyphicon-ok"></span>
                    </span>
                  </span>
                </div>
                <div class="plan-amount">
                  <div class="price">
                    <div class="sup"> $ </div>
                    <div class="monthly-amount"> 0.00 </div>
                  </div>
                  <div class="price-details">
                    <div class="crossed-out-price">
                      <div class="crossed-out-monthly-amount">$9.99</div>
                    </div>
                    <div class="per-month"> / Month </div>
                  </div>
                </div>
                <div class="divider"></div>
                <div class="thirty-day"> Free 30 days premium plan. </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-block d-md-none mt-4">
                <!-- <p>All amounts shown are in <b>USD</b>.</p> -->
                <button type="button" class="btn btn-choose btn-block my-5" style="margin: 0px;" @click="applyFreeTrial($event)">Apply</button> 
                <div class="order-summary-box">
                   <h4>With magicNZB you get</h4>
                   <ul class="checkmark fa-ul">
                      <li><i class="fa-li fas fa-check"></i> Multiple Usenet Providers included</li>
                      <li><i class="fa-li fas fa-check"></i> <em>Ultra-fast</em> unlimited Speed</li>
                      <li><i class="fa-li fas fa-check"></i> 4800+ Days Retention</li>
                      <li><i class="fa-li fas fa-check"></i> Stream Videos anywhere</li>
                      <li><i class="fa-li fas fa-check"></i> Download 24/7 to and from magicNZB</li>
                   </ul>
                </div>
             </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['premium','premium_end'],
    data() {
      return {
        form: {}
      };
    },
    methods: {
      setSelected(e,months){
        $('.try-yearly-plan').addClass("d-none");
        $('.alert-six-months').addClass("d-none");
        $('.plan').removeClass("selected");
        $('#'+e.currentTarget.id).addClass("selected");
        if(months == 1 || months == 6){
          $('.try-yearly-plan').removeClass("d-none");
        }

      },
      applyFreeTrial(e){

        $('button.btn-choose').prop('disabled', true).html('<i class="fas fa-spinner fa-pulse"></i>');

        axios.post('/api/free-trial').then(response=>{

          $('button.btn-choose').prop('disabled', false).html('Apply');

          if(response.data.status == 'success'){
            flash('Premium membership was activated.', 'success');
            setTimeout( () => window.location.href = '/account', 5000);
          } 
         
        }).catch(error=>{
            flash("Can't apply free trial, you already have an active premium membership.", 'error');
            $('button.btn-choose').prop('disabled', false).html('Apply');
        });
      },
      
    }
  }
</script>
